export default "__VITE_ASSET__CK2SHRfk__"